import { render, staticRenderFns } from "./NotificationsSettingsListEntryType.vue?vue&type=template&id=163ea6a7&scoped=true"
import script from "./NotificationsSettingsListEntryType.vue?vue&type=script&lang=js"
export * from "./NotificationsSettingsListEntryType.vue?vue&type=script&lang=js"
import style0 from "./NotificationsSettingsListEntryType.vue?vue&type=style&index=0&id=163ea6a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163ea6a7",
  null
  
)

export default component.exports